import { AdminConsentRequestPolicy } from '@microsoft/microsoft-graph-types-beta';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { Status, initialStatus } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'adminConsentRequestPolicy';

export interface State extends Status {
    data: AdminConsentRequestPolicy;
}

export const initialState: State = {
    data: null,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    // load

    on(actions.loadAdminConsentRequestPolicySuccess, (state, action) => ({
        ...state,
        data: action.policy,
        error: false,
        loaded: true,
    })),
    on(actions.loadAdminConsentRequestPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    on(actions.updateAdminConsentRequestPolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.updateAdminConsentRequestPolicySuccess, (state, action) => {
        return {
            ...state,
            data: action.data,
            updating: false,
            error: false,
        };
    }),
    on(actions.updateAdminConsentRequestPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),
);

export const selectPolicy = (state: State) => state.data;
export const selectError = (state: State) => state.error;
